var _excluded = ["children", "level", "shadowStrength", "variant", "aria-orientation", "role"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { useDeprecation } from '../_hooks/Deprecation';
import { StyledCardContainer } from './Card.styles';
/**

 We use cards to display information that is grouped together.
 Cards may contain rich media, text, buttons, and other functionality.

 @since 10.19.0

 @see [Storybook](https://stories.core.procore.com/?path=/story/core-react_demos-card--demo)

 @see [Design Guidelines](https://design.procore.com/card)

 */
export var Card = /*#__PURE__*/React.forwardRef(function Card(_ref, ref) {
  var children = _ref.children,
    level = _ref.level,
    _ref$shadowStrength = _ref.shadowStrength,
    shadowStrength = _ref$shadowStrength === void 0 ? 1 : _ref$shadowStrength,
    variant = _ref.variant,
    ariaOrientation = _ref['aria-orientation'],
    role = _ref.role,
    props = _objectWithoutProperties(_ref, _excluded);
  useDeprecation({
    when: level,
    oldThing: 'level',
    newThing: 'shadowStrength'
  });
  var roleAttributes = role && role !== 'none' && role !== 'presentation' ? {
    role: role,
    'aria-orientation': ariaOrientation
  } : {};
  return /*#__PURE__*/React.createElement(StyledCardContainer, _extends({}, props, roleAttributes, {
    $level: level,
    $shadowStrength: shadowStrength,
    $variant: variant,
    ref: ref
  }), children);
});
Card.displayName = 'Card';
//# sourceMappingURL=Card.js.map